import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { StatusHistoryResponse } from 'features/PlacementsStatus/types';

interface IPlacementStatusHistoryStore {
  loading: boolean;
  statusHistory: StatusHistoryResponse;
}

const initialState: IPlacementStatusHistoryStore = {
  loading: false,
  statusHistory: {} as StatusHistoryResponse,
};

const reset: CaseReducer<IPlacementStatusHistoryStore> = () => initialState;

const statusHistory: CaseReducer<
  IPlacementStatusHistoryStore,
  PayloadAction<StatusHistoryResponse>
> = (state, action) => {
  state.statusHistory = action.payload;
};

export const placementsStatusHistorySlice = createSlice({
  name: 'placementsStatusHistory',
  initialState,
  reducers: {
    loading: loading as IReducer<IPlacementStatusHistoryStore, boolean>,
    statusHistory,
    reset,
  },
});

const {
  loading: setLoading,
  statusHistory: setStatusHistory,
  reset: setReset,
} = placementsStatusHistorySlice.actions;

export const getPlacementsStatusHistory =
  (cardId: number, subtype?: string): AppThunk =>
  dispatch => {
    get<StatusHistoryResponse>(`/api/standards/placements/${cardId}/status_history/`, {
      subtype: subtype,
    }).then(({ data }) => {
      dispatch(setStatusHistory(data));
    });
  };

export { setLoading, setReset };
